import './style/reset.css';
import './style/common.css';
import Router from './component/router/router';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet-async';

ReactGA.initialize("G-SPYKK7P2WN");

function App() {
  return (
    <>
      <Helmet>
        <title>메이플스토리 전투력 측정기</title>
        <meta
          name="description"
          content="메이플스토리 캐릭터를 검색하여 전투력, 능력치, 장비 아이템 등을 확인해보세요."
        />
        <meta 
          name="keyword"
          content="메이플스토리, 메이플, 전투력, 측정기, OPEN API, 사이트, 캐릭터, 검색, 능력치, 스킬, 아이템, Maplestory, KMS, maple, stat, item, equipment, skill, search, website"
        />
        <meta property="og:image" content="/image/og/og.png" />
      </Helmet>
      <Router />
    </>
  );
}

export default App;
